import React from 'react';
import _ from 'lodash';
import { TableCell } from '@material-ui/core';

interface MainMarketHeadersProps {
  mainMarket: {
    headers: {
      outcomeName: string
    }[],
    vars: number,
  },
  collapsed: boolean
}

function MainMarketHeaders({ mainMarket, collapsed }: MainMarketHeadersProps) {
  const cellWidth = 144 / ((Object.keys(mainMarket.headers).length <= 3 && mainMarket.vars !== 0 ? 1 : 0) + mainMarket.headers.length);

  return (
    <>
      {
        Object.keys(mainMarket.headers).length <= 3 &&
        mainMarket.vars !== 0 && (
          <TableCell align="center" style={ { width: `${ cellWidth }px` } }></TableCell>
        )
      }

      {
        _.map(mainMarket.headers, (header, k) => (
          <TableCell key={ k } align="center" style={ { width: `${ cellWidth }px` } }>{ !collapsed ? header.outcomeName : '' }</TableCell>
        ))
      }

      { Object.keys(mainMarket.headers).length <= 3 && <TableCell align="center" className="sport-table__divider"></TableCell> }
    </>
  );
}

export default MainMarketHeaders;
